import { RouteConfig } from 'vue-router';
const PAGE_TITLE = ' 渝港澳青少年自然探索大赛公益活动';
const baseUrl = 'nature-explorer';
const route: RouteConfig = {
  path: `/${baseUrl}`,
  name: baseUrl,
  component: () => import('./ViewHolder.vue'),
  redirect: `/${baseUrl}/home`,
  meta: {
    title: PAGE_TITLE,
  },
  children: [
    {
      path: 'home',
      name: `${baseUrl}-home`,
      component: () => import('./pages/Home.vue'),
      meta: {
        title: PAGE_TITLE,
        rank: 1,
      },
    },
    {
      path: 'list',
      name: `${baseUrl}-list`,
      component: () => import('./pages/List.vue'),
      meta: {
        title: PAGE_TITLE,
        rank: 2,
        keepPosition: true,
      },
    },
    {
      path: 'winterList',
      name: `${baseUrl}-winterList`,
      component: () => import('./pages/WinterList.vue'),
      meta: {
        title: PAGE_TITLE,
        rank: 2,
        keepPosition: true,
      },
    },
    {
      path: 'summer-list',
      name: `${baseUrl}-summer-list`,
      component: () => import('./pages/SummerList.vue'),
      meta: {
        title: PAGE_TITLE,
        rank: 2,
      },
    },
    {
      path: 'news',
      name: `${baseUrl}-news`,
      component: () => import('./pages/NewsList.vue'),
      meta: {
        title: PAGE_TITLE,
      },
    },
    {
      path: 'rules',
      name: `${baseUrl}-rules`,
      component: () => import('./pages/Rules.vue'),
      meta: {
        title: PAGE_TITLE,
      },
    },
    // * 隐藏春报名路由
    // {
    //   path: 'save',
    //   name: `${baseUrl}-save`,
    //   component: () => import('./pages/Save.vue'),
    //   meta: {
    //     title: PAGE_TITLE,
    //     rank: 3,
    //   },
    // },
    {
      path: 'save-summer',
      name: `${baseUrl}-save-summer`,
      component: () => import('./pages/SummerSave.vue'),
      meta: {
        title: PAGE_TITLE,
        rank: 3,
      },
    },
    {
      path: 'build',
      name: `${baseUrl}-build`,
      component: () => import('./pages/Build.vue'),
      meta: {
        title: PAGE_TITLE,
      },
    },
    {
      path: 'detail',
      name: `${baseUrl}-detail`,
      component: () => import('./pages/Detail.vue'),
      meta: {
        title: PAGE_TITLE,
        rank: 3,
      },
    },
    {
      path: 'winterDetail',
      name: `${baseUrl}-winterDetail`,
      component: () => import('./pages/WinterDetail.vue'),
      meta: {
        title: PAGE_TITLE,
        rank: 3,
      },
    },
    {
      path: 'winterSave',
      name: `${baseUrl}-winterSave`,
      component: () => import('./pages/WinterSave.vue'),
      meta: {
        title: PAGE_TITLE,
        rank: 3,
      },
    },
    {
      path: 'save',
      name: `${baseUrl}-save`,
      component: () => import('./pages/Save.vue'),
      meta: {
        title: PAGE_TITLE,
        rank: 3,
      },
    },
    {
      path: 'autumn',
      name: `${baseUrl}-autumn`,
      component: () => import('./pages/Autumn.vue'),
      meta: {
        title: PAGE_TITLE,
        rank: 3,
      },
    },
  ],
};

export default route;
